import React, { Component } from "react";
import { Doughnut } from "react-chartjs-2";
import { connect } from "react-redux";
import { openModal } from "../../../../store/actions/ModalActions";
import { unredeemed_pawns_chart_data } from "../../../../constants/chart_definitions";
import NoChartData from "../../../../components/extensions/ErrorPageDefaults/NoChartData";
import PieChartLoader from "../../../../components/extensions/PieChartLoader";

import { GetUnredeemedPawnOverallV4 } from "../../../../store/actions/reports-v4/unredeemedpawn_service_actions";

import { AspectRatio, Search } from "@material-ui/icons";

import { IconButton, Toolbar } from "@material-ui/core";

import * as d3 from "d3";
import { interpolateColors } from "../../../../helpers/colorGenerator";
import UnredeemedPawnsViewFilter from "../../view_filters/UnredeemedPawns/UnredeemedPawnsViewFilter";
import { ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import { DashboardContext } from "../../dashboard_context";
import {
  moduleNames,
  OperationScope,
} from "../../../../helpers/dashboardModuleNames";
import ModuleLocked from "../../../../components/extensions/ModuleLockedView";
import { renderChartTitle } from "../../../../helpers/chartTitleBuilder";
import moment from "moment";
import { SetChartUnredeemedPawnsTitle } from "../../../../store/actions/reports/chart_title_actions";
import { numberWithCommas } from "../../../../helpers/dataHelpers";

const fromDate = new Date();
const toDate = new Date();

fromDate.setMonth(fromDate.getMonth());
toDate.setMonth(toDate.getMonth());

const unredeemedpawn_filter = {
  from: moment(fromDate).format("YYYY-MM-DD"),
  to: moment(toDate).format("YYYY-MM-DD"),
};

class UnredeemedPawnView extends Component {
  state = {
    isLoading: false,
    dataSet: {
      items: [],
      labels: [],
      colors: [],
    },
    dates: unredeemedpawn_filter,
    toView: "piece",
    clusterId: null,
    areaId: null,
    areaSelectContext: null,
    clusterSelectContext: null,
  };

  componentDidMount() {
    this.premiseGetUnredeemedPawnOverallV4({
      covered_date: this.state.dates.from,
    }).then(() => {
      this.initializeData();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.unredeemedpawn_list !== this.props.unredeemedpawn_list) {
      this.setState({ isLoading: true });

      this.initializeData();
    }
  }

  initializeData = () => {
    this.appendChartData();
  };

  appendChartData = () => {
    this.setState({ isLoading: true });

    let { unredeemedpawn_list } = this.props;
    var colorScale = d3.interpolateHclLong("#34ace0", "orange");

    let { toView } = this.state;

    let temppackage_list = [];
    if (unredeemedpawn_list) {
      temppackage_list.push({
        name: "New",
        value:
          toView === "piece"
            ? unredeemedpawn_list.newPawnSummaries.totalPieces
            : unredeemedpawn_list.newPawnSummaries.totalPrincipal,
      });
      temppackage_list.push({
        name: "Past Due",
        value:
          toView === "piece"
            ? unredeemedpawn_list.pastDueSummaries.totalPieces
            : unredeemedpawn_list.pastDueSummaries.totalPrincipal,
      });
      temppackage_list.push({
        name: "Overdue",
        value:
          toView === "piece"
            ? unredeemedpawn_list.overDueSummaries.totalPieces
            : unredeemedpawn_list.overDueSummaries.totalPrincipal,
      });
      temppackage_list.push({
        name: "Long Overdue",
        value:
          toView === "piece"
            ? unredeemedpawn_list.longOverDueSummaries.totalPieces
            : unredeemedpawn_list.longOverDueSummaries.totalPrincipal,
      });
    }

    let data = temppackage_list;

    var tempDataset = {
      ...this.state.dataSet,
      items: data.map((item) => item.value),
      labels: data.map(
        (item) =>
          `${item.name} (${numberWithCommas(
            item.value,
            this.state.toView === "piece" ? 0 : 2
          )})`
      ),
      colors: interpolateColors(data.length, colorScale, {
        colorStart: 0,
        colorEnd: 1,
        useEndAsStart: true,
      }),
    };

    this.setState({ dataSet: tempDataset }, () => {
      this.setState({
        isLoading: false,
      });
    });
  };

  handleRadioChanged = (e) => {
    this.setState(
      {
        toView: e,
        clusterId: null,
        areaId: null,
        areaSelectContext: null,
        clusterSelectContext: null,
      },
      () => {
        this.appendChartData();
      }
    );
  };

  renderDoughnut = (data) => {
    return (
      <Doughnut
        options={{
          title: {
            display: false,
            text: this.props.chartTitle,
            fontsize: 20,
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 120,
              bottom: 100,
            },
          },
          legend: {
            display: true,
            position: "left",
          },
          plugins: {
            datalabels: {
              display: false,
            },
            outlabels: {
              stretch: 15,
              lineColor: "#212121",
            },
          },
        }}
        data={unredeemed_pawns_chart_data(data)}
      />
    );
  };

  renderOptions = () => {
    let hasContent = this.validateChartHasValue();

    return (
      <Toolbar className="float-right">
        <ToggleButtonGroup
          onChange={this.handleRadioChanged}
          size="sm"
          name="filterByRadio"
          type="radio"
          value={this.state.toView}
        >
          <ToggleButton size="sm" variant="light" value="piece">
            Piece
          </ToggleButton>
          <ToggleButton size="sm" variant="light" value="principal">
            Principal
          </ToggleButton>
        </ToggleButtonGroup>
        <IconButton
          onClick={() => {
            this.props.openModal({
              custom: false,
              size: "lg",
              title: "Unredeemed Pawns",
              currentComponent: (
                <UnredeemedPawnsViewFilter Refresh={this.appendChartData} />
              ),
            });
          }}
        >
          <Search />
        </IconButton>

        <IconButton
          hidden={!hasContent}
          onClick={() => {
            this.props.openModal({
              custom: true,
              size: "lg",
              title: "Unredeemed Pawns",
              currentComponent: (
                <>
                  <strong>{this.props.chartTitle}</strong>
                  <Doughnut
                    options={{
                      title: {
                        display: false,
                        text: this.props.chartTitle,
                        fontsize: 20,
                      },
                      layout: {
                        padding: {
                          left: 0,
                          right: 0,
                          top: 120,
                          bottom: 100,
                        },
                      },
                      legend: {
                        display: true,
                        position: "left",
                      },
                      plugins: {
                        datalabels: {
                          display: false,
                        },
                        outlabels: {
                          stretch: 20,
                          lineColor: "#212121",
                        },
                      },
                    }}
                    data={unredeemed_pawns_chart_data(this.state.dataSet)}
                  />
                </>
              ),
            });
          }}
        >
          <AspectRatio />
        </IconButton>
        <ModuleLocked
          Lock={() => this.context.Lock(moduleNames.unredeemedPawns)}
          Unlock={() => this.context.Unlock(moduleNames.unredeemedPawns)}
          isLocked={this.context.unredeemedPawnsLocked}
        />
      </Toolbar>
    );
  };

  validateChartHasFullValue = () => {
    let { unredeemedpawn_list } = this.props;

    var validatedList = [];

    let {
      newPawnSummaries,
      pastDueSummaries,
      overDueSummaries,
      longOverDueSummaries,
    } = unredeemedpawn_list;

    validatedList.push(
      newPawnSummaries.totalPieces === 0 &&
        newPawnSummaries.totalPrincipal === 0
    );
    validatedList.push(
      pastDueSummaries.totalPieces === 0 &&
        pastDueSummaries.totalPrincipal === 0
    );
    validatedList.push(
      overDueSummaries.totalPieces === 0 &&
        overDueSummaries.totalPrincipal === 0
    );
    validatedList.push(
      longOverDueSummaries.totalPieces === 0 &&
        longOverDueSummaries.totalPrincipal === 0
    );

    return validatedList.some((x) => x === true);
  };

  validateChartHasValue = () => {
    let { items } = this.state.dataSet;
    return items.some((x) => x > 0);
  };

  renderChart = () => {
    let hasContent = this.validateChartHasValue();

    return (
      <div>
        {hasContent ? (
          <>
            <strong>{this.props.chartTitle}</strong>

            {this.renderDoughnut(this.state.dataSet)}
          </>
        ) : (
          <NoChartData />
        )}
        {this.renderOptions()}
      </div>
    );
  };

  render() {
    return this.state.isLoading ? (
      <PieChartLoader />
    ) : (
      <div>{this.renderChart()}</div>
    );
  }

  premiseGetUnredeemedPawnOverallV4 = (dates) => {
    this.setState({ isLoading: true });

    var chartTitle = renderChartTitle(
      moduleNames.unredeemedPawns,
      OperationScope.overall,
      moment(dates.from).format("MMMM DD YYYY")
    );

    this.props.SetChartUnredeemedPawnsTitle(chartTitle);

    return this.props.GetUnredeemedPawnOverallV4(dates);
  };
}

const mapStateToProps = (state) => {
  return {
    chartTitle: state.chart_title.unredeemedPawns,

    unredeemedpawn_list: state.unredeemed_pawns.unredeemed_pawns_list,
  };
};

const mapDispatchToProps = {
  openModal: openModal,
  SetChartUnredeemedPawnsTitle: SetChartUnredeemedPawnsTitle,
  GetUnredeemedPawnOverallV4: GetUnredeemedPawnOverallV4,
};

UnredeemedPawnView.contextType = DashboardContext;

export default connect(mapStateToProps, mapDispatchToProps)(UnredeemedPawnView);
